/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropKickVodResponse
 */
export interface DropKickVodResponse {
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof DropKickVodResponse
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof DropKickVodResponse
     */
    viewCount: number;
    /**
     * 
     * @type {string}
     * @memberof DropKickVodResponse
     */
    hlsUrl?: string;
}

/**
 * Check if a given object implements the DropKickVodResponse interface.
 */
export function instanceOfDropKickVodResponse(value: object): value is DropKickVodResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    if (!('viewCount' in value) || value['viewCount'] === undefined) return false;
    return true;
}

export function DropKickVodResponseFromJSON(json: any): DropKickVodResponse {
    return DropKickVodResponseFromJSONTyped(json, false);
}

export function DropKickVodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropKickVodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'],
        'createdAt': json['createdAt'],
        'durationSeconds': json['durationSeconds'],
        'viewCount': json['viewCount'],
        'hlsUrl': json['hlsUrl'] == null ? undefined : json['hlsUrl'],
    };
}

export function DropKickVodResponseToJSON(json: any): DropKickVodResponse {
    return DropKickVodResponseToJSONTyped(json, false);
}

export function DropKickVodResponseToJSONTyped(value?: DropKickVodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
        'createdAt': value['createdAt'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
        'hlsUrl': value['hlsUrl'],
    };
}

